enum XComEventDirection {
    Inbound,
    OutBound
}

export { XComEventDirection };
